module.exports = __webpack_public_path__ + "static/media/sydney.fcbf1723.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/video/sydney.mov
// module id = 533
// module chunks = 0